var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": _vm.logoUrl
    }
  }), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("fallback.lost")))]), _c('h4', [_vm._v(_vm._s(_vm.$t("fallback.missing_page")))]), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t("fallback.home")))])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }